export default {"src":"/_next/static/media/gold.e08d4e7c.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};